const INITIAL_STATE = {
    reservas: {data: []}
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'RESERVAS_MOTIVOS_FETCHED':
            return { ...state, reservas: action.payload }
        default:
            return state
    }
}